import cache from '../helpers/cache'
import { DIMENSION_OPTIONS, DIMENSION_STATE } from '../helpers/config'
import country from './country'
import chart from './chart'

const dimensionOptions = [
    {
        label: "Country",
        value: "country",
        schemaName: "Talkwalker.extraSourceAttributesWorldDataCountry",
        options: country.getCountries()
    },
    {
        label: "Gender",
        value: "gender",
        schemaName: "Talkwalker.extraAuthorAttributesGender",
        options: [
            { label: "Male", value: 'male' },
            { label: "Female", value: 'female' },
            { label: "Uknown", value: 'unknown' }
        ]
    },
    {
        label: "Source Type",
        value: "source_type",
        schemaName: "Talkwalker.sourceType",
        options: [
            { label: "Online News", value: 'online_news' },
            { label: "Twitter", value: 'twitter' },
            { label: "Other", value: 'other' }
        ]
    },
    {
        label: "Languages",
        value: "languages",
        schemaName: "Talkwalker.lang",
        options: [
            { label: "English", value: 'english' },
            { label: "Arabic", value: 'arabic' },
            { label: "Italian", value: 'italian' },
            { label: "German", value: 'german' },
            { label: "Ukrainian", value: 'ukrainian' },
            { label: "Other", value: 'other' }
        ]
    },
    {
        label: 'Sentiment',
        value: 'sentiment',
        schemaName: 'Talkwalker.sentiment',
        options: [
            { label: 'Positive', value: 'positive' },
            { label: 'Neutral', value: ' neutral' },
            { label: 'Negative', value: 'negative' },
        ]
    }
]

const getDimensionOptions = () => (cache.getItem(DIMENSION_OPTIONS))

const setDimensionOptions = (dimOptions) => {
    cache.setItem(DIMENSION_OPTIONS, dimOptions || dimensionOptions)
}

const getDimensionOption = (name) => {
    return getDimensionOptions().find(d => (name == d.dimension))
}

const getDimensionStates = () => (cache.getItem(DIMENSION_STATE))

const setDimensionStates = (dimensionStates) => {
    cache.setItem(DIMENSION_STATE, dimensionStates || {})
}

const getDimensionState = (key) => (getDimensionStates()[key])

const setDimensionState = (key, value) => {
    let dimensionStates = getDimensionStates()
    if (!dimensionStates) dimensionStates = {}
    dimensionStates[key] = value
    setDimensionStates(dimensionStates)
}

const removeDimensionState = (key) => {
    let dimensionStates = getDimensionStates()
    delete dimensionStates[key]
    setDimensionStates(dimensionStates)
}

const removeDimensionStates = () => { setDimensionStates() }

const mapValueToDimFilter = (dimension, values, oldFilters) => {

    let updatedFilter = oldFilters?.filter(f => (
        !f.member.includes(dimension.schemaName))
    ) || []

    removeDimensionState(dimension.value)

    if (values.length > 0) {
        let filterValues = values.map((value) => {
            return dimension.options.find(option => (option.value == value)).label
        })

        updatedFilter.push({
            member: dimension.schemaName,
            operator: 'equals',
            values: filterValues
        })

        setDimensionState(dimension.value, values)
    }

    return updatedFilter
}

const mapStateToFilters = (state) => {
    let updatedFilter = Object.keys(state)
        .filter(key => key !== 'date_range')
        .map(key => {
            let dimension = dimensionOptions
                .find(dimensionOption => dimensionOption.value == key)
            let filterValues = state[key]
                .map(value =>
                    dimension.options.find(option => option.value == value).label
                )
            return {
                member: dimension.schemaName,
                operator: 'equals',
                values: filterValues
            }
        })
        .filter(filter => !!filter.values && filter.values.length > 0)
    return updatedFilter
}

const mapDimFilterToValue = (dashboardItem) => {

    let dashboardFilter = JSON.parse(dashboardItem.vizState).query.filters

    let fState = {}
    dashboardFilter.forEach((filter) => {
        let dim = getDimensionOptions().find((option) => (option.schemaName == filter.member))

        let dimValues = filter.values.map((value) => (
            dim.options.find((option) => (
                option.label == value
            )).value
        ))

        fState[dim.value] = dimValues

    })

    console.log("fState, ", fState)
    setDimensionStates(fState)

    return fState

}

const resetAllDimFilters = () => {
    let dashboardItems = chart.getLocalDashboardItems()
    let updatedDashboardItems = dashboardItems.map((dashboardItem) => {
        let updatedVizState = JSON.parse(dashboardItem.vizState)
        updatedVizState.query.filters = []
        return {
            ...dashboardItem,
            vizState: JSON.stringify(updatedVizState)
        }
    })

    chart.setLocalDashboardItems(updatedDashboardItems)
    chart.setDashboard({ dashboardItems: updatedDashboardItems })

    let fState = {}
    getDimensionOptions().map((dimOption) => {
        fState[dimOption.value] = []
    })

    return fState
}

export default {
    getDimensionOptions, setDimensionOptions,
    getDimensionOption,
    mapValueToDimFilter,
    mapStateToFilters,
    mapDimFilterToValue,
    resetAllDimFilters,
    getDimensionStates, setDimensionStates
}